import React from 'react';
import PropTypes from 'prop-types';

import { Redirect } from 'react-router';

import {
  Link,
  Tooltip,
  Typography,
} from '@material-ui/core';

import { UserContext } from "../../user";
import { fmtClient } from "../formatters";

export default function ClientAccount(props) {
  const { value, variant, linked } = props;

  const [ navToClient, setNavToClient ] = React.useState(null);
  
  const userContext=React.useContext(UserContext);
  const accountIds=value.constructor === Array?value:[value];
  const clientNames=accountIds.map((id) => {
    return {
      id: id,
      name: userContext?fmtClient(id,userContext):id
    };
  });
  if(navToClient) {
    return <Redirect push to={"/Clients/"+navToClient} />;  
  }
  return (
    <React.Fragment>
      {
        clientNames.map((client, index) => {
          const separator=index>0?', ':'';
          if(client.id !== client.name) {
            return(
                <Tooltip key={index} title={
                      <Typography variant={variant}>{"Account Id: "+client.id}</Typography>
                    } enterDelay={1000} leaveDelay={200} arrow>
                  {linked?
                    <Link onClick={() => setNavToClient(client.id)}>
                      <Typography variant={variant}>{separator+client.name}</Typography>
                    </Link>
                    :
                    <Typography variant={variant}>{separator+client.name}</Typography>
                  }
                </Tooltip>
            );
          } else { 
            return(
                <Typography key={index} variant={variant}>{separator+client.name}</Typography>
            );
          }
          
        })
      }
    </React.Fragment>
  );
}

ClientAccount.propTypes = {
  value: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired,
  linked: PropTypes.bool.isRequired,
};

ClientAccount.defaultProps = {
  variant: 'inherit',
  linked: true,
};
